import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  imageWrapper: {
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  imageHolder: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  colorHolder: {
    height: '20px',
    width: '20px',
    minWidth: '20px',
    borderRadius: '5px',
    margin: '5px',
  },
  colorCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
  },
}))
